import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// eslint-disable-next-line
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import schema from './apollo-schema.json';
import USE_MARKETPLACE from '~/const/marketplace';
var fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: schema
});
export default function (_ref) {
  var store = _ref.store,
      req = _ref.req;

  var _ref2 = req || {},
      _ref2$header = _ref2.header,
      header = _ref2$header === void 0 ? {} : _ref2$header;

  var _store$getters$shared = store.getters['sharedEnv/getSharedEnv'],
      graphqlExternal = _store$getters$shared.graphqlExternal,
      graphqlInternal = _store$getters$shared.graphqlInternal;
  var locale = store.getters['i18n/locale'];
  var useCatalogv1 = store.$cookies.get('usecatalogv1');
  var displayMkpProducts = USE_MARKETPLACE({
    locale: locale,
    $cookies: store.$cookies
  });
  var xMdM = Object.entries(header).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];

    return /^x-mdm-/i.test(key);
  }).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    acc[key] = value;
    return acc;
  }, {});
  return {
    httpEndpoint: process.browser ? graphqlExternal : graphqlInternal,
    httpLinkOptions: {
      headers: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, xMdM), header['correlation-id'] && {
        'correlation-id': header['correlation-id']
      }), header['mdm-client-ip'] && {
        'mdm-client-ip': header['mdm-client-ip']
      }), {
        'Ws-Cat-Version': useCatalogv1 ? 1 : 2
      }), displayMkpProducts && {
        'Source-Mkp-Products': 1
      }), {}, {
        'Accept-Language': locale.iso
      })
    },
    cache: new InMemoryCache({
      fragmentMatcher: fragmentMatcher
    })
  };
}